import { ShuffleBracketNode } from "model/Bracket/ShuffleBracketGraph";
import { selectMatch } from "selectors/Match";
import { ErrorText } from "styles/text";
import { EmptyMatchContainer } from "../Match/styles";
import { ShuffleBracketMatch } from "./ShuffleMatch/ShuffleBracketMatch";
import { useAppSelector } from "app/hooks";

interface Props {
  node: ShuffleBracketNode;
  tournamentId: string;
}

export const ShuffleBracketRowMatch = ({ node, tournamentId }: Props) => {
  const matchId = node.match.matchId;
  const match = useAppSelector((state) => selectMatch(state, matchId));
  if (!match) {
    return (
      <EmptyMatchContainer>
        <ErrorText>Can't resolve match {node.match.matchId}</ErrorText>
      </EmptyMatchContainer>
    );
  }

  return (
    <ShuffleBracketMatch
      node={node}
      match={match}
      tournamentId={tournamentId}
    />
  );
};
